import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
import __megamenu from "./jsons/__megamenu.json";

import { ChatBubbleOvalLeftIcon, InboxIcon } from "@heroicons/react/24/outline";

import {
  QrCodeIcon,
  StarIcon,
  BuildingOffice2Icon,
  ArrowTrendingUpIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  GiftIcon,
  ArrowDownTrayIcon,
  LifebuoyIcon,
  FireIcon,
  BookOpenIcon,
  PhoneIcon,
  UserIcon,
  UserPlusIcon,
  HomeIcon,
  CurrencyDollarIcon,
  PlayIcon,
  MapIcon,
} from "@heroicons/react/24/outline";

import {
  UserCircleIcon,
  LockClosedIcon,
  ChatBubbleBottomCenterTextIcon,
} from "@heroicons/react/24/outline";

import { MdDashboard, MdCalendarMonth, MdCardGiftcard } from "react-icons/md";
import { TbClipboardList } from "react-icons/tb";
import { FiUser, FiMessageSquare } from "react-icons/fi";
import { FaQrcode } from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";
import { HiOutlineBookmark } from "react-icons/hi2";
import { HiOutlineCreditCard } from "react-icons/hi";
import { GiWallet } from "react-icons/gi";

export const loyaltychild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/royalty",
    name: "Your Scores",
    subtitle: "View your loyalty points & rewards",
    isNew: true,
    icon: StarIcon,
  },
  {
    id: ncNanoId(),
    href: "/home-3",
    name: "Following",
    subtitle: "See businesses you follow",
    isNew: true,
    icon: ArrowTrendingUpIcon,
  },
];

// MENU (Business Section)
export const BusinessChild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
    icon: FireIcon,
  },
  { id: ncNanoId(), href: "/blog", name: "Blog Page", icon: BookOpenIcon },
  {
    id: ncNanoId(),
    href: "/blog-single",
    name: "Blog Single",
    icon: BookOpenIcon,
  },
  { id: ncNanoId(), href: "/about", name: "About", icon: UserCircleIcon },
  { id: ncNanoId(), href: "/contact", name: "Contact us", icon: PhoneIcon },
  { id: ncNanoId(), href: "/login", name: "Login", icon: UserIcon },
  { id: ncNanoId(), href: "/signup", name: "Signup", icon: UserPlusIcon },
  {
    id: ncNanoId(),
    href: "/subscription",
    name: "Subscription",
    icon: CurrencyDollarIcon,
  },
];

// Best Deals Section
export const Bestdealchild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
    type: "dropdown",
    icon: FireIcon,
    children: Array.from({ length: 10 }, (_, i) => ({
      id: ncNanoId(),
      href: `/add-listing-${i + 1}`,
      name: `Add Listings ${i + 1}`,
      icon: FireIcon,
    })),
  },
  {
    id: ncNanoId(),
    href: "/checkout",
    name: "Checkout",
    icon: CurrencyDollarIcon,
  },
  {
    id: ncNanoId(),
    href: "/pay-done",
    name: "Pay done",
    icon: CurrencyDollarIcon,
  },
  { id: ncNanoId(), href: "/author", name: "Author Page", icon: UserIcon },
  {
    id: ncNanoId(),
    href: "/account",
    name: "Account Page",
    icon: UserCircleIcon,
  },
];

// Blog Menu
export const blogchild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
    icon: FireIcon,
  },
  { id: ncNanoId(), href: "/blog", name: "Blog Page", icon: BookOpenIcon },
  {
    id: ncNanoId(),
    href: "/blog-single",
    name: "Blog Single",
    icon: BookOpenIcon,
  },
  { id: ncNanoId(), href: "/about", name: "About", icon: UserCircleIcon },
  { id: ncNanoId(), href: "/contact", name: "Contact us", icon: PhoneIcon },
];

// About Menu
export const aboutchild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/about",
    name: "About",
    icon: UserCircleIcon,
    subtitle: "",
  },
  { id: ncNanoId(), href: "/contact", name: "Contact us", icon: PhoneIcon },
  { id: ncNanoId(), href: "/login", name: "Login", icon: UserIcon },
  { id: ncNanoId(), href: "/signup", name: "Signup", icon: UserPlusIcon },
];

// Profile Menu
// export const profilechild: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/account",
//     name: "Update Profile",
//     subtitle: "Edit name, email, photo, etc.",
//     icon: UserCircleIcon,
//   },
//   {
//     id: ncNanoId(),
//     href: "/qr-code",
//     name: "QR code",
//     subtitle: "Scan to earn loyalty points",
//     icon: QrCodeIcon,
//   },
//   {
//     id: ncNanoId(),
//     href: "/password",
//     name: "Change Password",
//     subtitle: "Update your login password",
//     icon: LockClosedIcon,
//   },
//   {
//     id: ncNanoId(),
//     href: "/userInbox",
//     name: "Message",
//     subtitle: "Check and reply to messages",
//     icon: ChatBubbleBottomCenterTextIcon,
//   },
// ];

// Appoint Menu
// export const appointmentchild: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/dashboard",
//     name: "Your upcomming appointment",
//     subtitle: "Edit name, email, photo, etc.",
//     icon: UserCircleIcon,
//   },
//   {
//     id: ncNanoId(),
//     href: "/qr-code",
//     name: "QR code",
//     subtitle: "Scan to earn loyalty points",
//     icon: QrCodeIcon,
//   },
//   {
//     id: ncNanoId(),
//     href: "/account-password",
//     name: "Change Password",
//     subtitle: "Update your login password",
//     icon: LockClosedIcon,
//   },
//   {
//     id: ncNanoId(),
//     href: "/userInbox",
//     name: "Message",
//     subtitle: "Check and reply to messages",
//     icon: ChatBubbleBottomCenterTextIcon,
//   },
// ];

export const appointmentchild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/dashboard",
    name: "Dashboard",
    subtitle: "View your appointment overview",
    icon: MdDashboard,
  },
  {
    id: ncNanoId(),
    href: "/booking",
    name: "Appointments",
    subtitle: "Manage your bookings",
    icon: MdCalendarMonth,
  },
  {
    id: ncNanoId(),
    href: "/orders",
    name: "Ordering",
    subtitle: "See and track your orders",
    icon: TbClipboardList,
  },
  {
    id: ncNanoId(),
    href: "/loyaltywallets",
    name: "Loyalty",
    subtitle: "Your loyalty points and rewards",
    icon: GiWallet,
  },
  // {
  //   id: ncNanoId(),
  //   href: "/loyalty",
  //   name: "Loyalty",
  //   subtitle: "Your loyalty points and rewards",
  //   icon: MdCardGiftcard,
  // },
  {
    id: ncNanoId(),
    href: "/loyaltywallet",
    name: "Loyalty Wallet",
    subtitle: "Your loyalty points and rewards",
    icon: HiOutlineCreditCard,
  },
];

export const profilechild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/account",
    name: "Update Profile",
    subtitle: "Edit your personal details",
    icon: FiUser,
  },
  {
    id: ncNanoId(),
    href: "/qr-code",
    name: "QR code",
    subtitle: "Scan to earn loyalty points",
    icon: FaQrcode,
  },
  {
    id: ncNanoId(),
    href: "/userInbox",
    name: "Message",
    subtitle: "View and reply to your messages",
    icon: FiMessageSquare,
  },
  {
    id: ncNanoId(),
    href: "/account-password",
    name: "Change Password",
    subtitle: "Update your login credentials",
    icon: RiLockPasswordLine,
  },
];

export const savedchild: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/account-savelists",
    name: "Save List",
    subtitle: "Your saved services or items",
    icon: HiOutlineBookmark,
  },
];

export const LOKALAI_MENU: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Service History",
    type: "megaMenu",
    children: appointmentchild,
    icon: StarIcon,
  },

  // {
  //   id: ncNanoId(),
  //   href: "/menu",
  //   name: "Ordering",
  //   type: "dropdown",
  //   children: BusinessChild,
  //   icon: FireIcon,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/",
  //   name: "Loyalty",
  //   type: "megaMenu",
  //   children: loyaltychild,
  //   icon: StarIcon,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/listing-stay",
  //   name: "best deals",
  //   type: "dropdown",
  //   isNew: true,
  //   icon: GiftIcon,
  //   children: Bestdealchild,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/blog",
  //   name: "Favorites",
  //   type: "dropdown",
  //   children: blogchild,
  //   icon: BookOpenIcon,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/about",
  //   name: "About",
  //   type: "dropdown",
  //   children: aboutchild,
  //   icon: BookOpenIcon,
  // },
  {
    id: ncNanoId(),
    href: "/account",
    name: "Account Setting",
    type: "dropdown",
    children: profilechild,
    icon: HomeIcon,
  },
  {
    id: ncNanoId(),
    href: "/account-savelists",
    name: "Saved",
    type: "dropdown",
    children: savedchild,
    icon: HomeIcon,
  },
];

// no login section

export const LOKALAI_MENU_Nologin: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "For customers",
    type: "dropdown",
    children: [
      {
        id: ncNanoId(),
        name: "Log in or Sign Up",
        icon: UserPlusIcon,
        action: "loginModal", // custom field to trigger modal
      },
      {
        id: ncNanoId(),
        href: "/gift-card",
        name: "Send a gift card demo",
        icon: GiftIcon,
      },
      {
        id: ncNanoId(),
        href: "/downloadapp",
        name: "Download the app",
        icon: ArrowDownTrayIcon,
      },
      {
        id: ncNanoId(),
        href: "/help-center",
        name: "Help and support",
        icon: LifebuoyIcon,
      },
    ],
  },
];

// const megaMenuDemo: MegamenuItem[] = [
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "Company",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "/unique_id_",
//       name: i.Company,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "App Name",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "/unique_id_",
//       name: i.AppName,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/5059013/pexels-photo-5059013.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "City",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "/unique_id_",
//       name: i.City,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/5159141/pexels-photo-5159141.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "Contruction",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "/unique_id_",
//       name: i.Contruction,
//     })),
//   },
//   {
//     id: ncNanoId(),
//     image:
//       "https://images.pexels.com/photos/7473041/pexels-photo-7473041.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     title: "Country",
//     items: __megamenu.map((i) => ({
//       id: ncNanoId(),
//       href: "/unique_id_",
//       name: i.Country,
//     })),
//   },
// ];

// const demoChildMenus: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/",
//     name: "Online Booking",
//   },
//   {
//     id: ncNanoId(),
//     href: "/home-2",
//     name: "Real Estate",
//     isNew: true,
//   },
//   {
//     id: ncNanoId(),
//     href: "/home-3",
//     name: "Home - 3",
//     isNew: true,
//   },
// ];

// const otherPageChildMenus: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/add-listing-1",
//     name: "+ Add Listings",
//   },
//   {
//     id: ncNanoId(),
//     href: "/blog",
//     name: "Blog Page",
//   },
//   {
//     id: ncNanoId(),
//     href: "/blog-single",
//     name: "Blog Single",
//   },
//   {
//     id: ncNanoId(),
//     href: "/about",
//     name: "About",
//   },
//   {
//     id: ncNanoId(),
//     href: "/contact",
//     name: "Contact us",
//   },
//   {
//     id: ncNanoId(),
//     href: "/login",
//     name: "Login",
//   },
//   {
//     id: ncNanoId(),
//     href: "/signup",
//     name: "Signup",
//   },
//   {
//     id: ncNanoId(),
//     href: "/subscription",
//     name: "Subscription",
//   },
// ];

// const templatesChildrenMenus: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/add-listing-1",
//     name: "+ Add Listings",
//     type: "dropdown",
//     children: [
//       {
//         id: ncNanoId(),
//         href: "/add-listing-1",
//         name: "Add Listings 1",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-2",
//         name: "Add Listings 2",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-3",
//         name: "Add Listings 3",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-4",
//         name: "Add Listings 4",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-5",
//         name: "Add Listings 5",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-6",
//         name: "Add Listings 6",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-7",
//         name: "Add Listings 7",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-8",
//         name: "Add Listings 8",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-9",
//         name: "Add Listings 9",
//       },
//       {
//         id: ncNanoId(),
//         href: "/add-listing-10",
//         name: "Add Listings 10",
//       },
//     ],
//   },
//   //
//   { id: ncNanoId(), href: "/checkout", name: "Checkout" },
//   { id: ncNanoId(), href: "/pay-done", name: "Pay done" },
//   //
//   { id: ncNanoId(), href: "/author", name: "Author Page" },
//   { id: ncNanoId(), href: "/account", name: "Account Page" },
// ];

// export const NAVIGATION_DEMO: NavItemType[] = [
//   {
//     id: ncNanoId(),
//     href: "/",
//     name: "Home",
//     type: "dropdown",
//     children: demoChildMenus,
//     isNew: true,
//   },
//   {
//     id: ncNanoId(),
//     href: "/unique_id_",
//     name: "Five columns",
//     type: "megaMenu",
//     megaMenu: megaMenuDemo,
//   },
//   {
//     id: ncNanoId(),
//     href: "/listing-stay",
//     name: "Listing Page",
//     type: "dropdown",
//     isNew: true,
//     children: [
//       {
//         id: ncNanoId(),
//         href: "/listing-stay",
//         name: "Stay listing",
//         type: "dropdown",
//         children: [
//           { id: ncNanoId(), href: "/listing-stay", name: "Stay page" },
//           {
//             id: ncNanoId(),
//             href: "/listing-stay-map",
//             name: "Stay page (map)",
//           },
//           { id: ncNanoId(), href: "/listing-stay-detail", name: "Stay Detail" },
//         ],
//       },

//       //
//       {
//         id: ncNanoId(),
//         href: "/listing-experiences",
//         name: "Experiences listing",
//         type: "dropdown",
//         children: [
//           {
//             id: ncNanoId(),
//             href: "/listing-experiences",
//             name: "Experiences page",
//           },
//           {
//             id: ncNanoId(),
//             href: "/listing-experiences-map",
//             name: "Experiences page (map)",
//           },
//           {
//             id: ncNanoId(),
//             href: "/listing-experiences-detail",
//             name: "Experiences Detail",
//           },
//         ],
//       },

//       //
//       {
//         id: ncNanoId(),
//         href: "/listing-car",
//         name: "Cars listing",
//         type: "dropdown",
//         children: [
//           { id: ncNanoId(), href: "/listing-car", name: "Cars page" },
//           { id: ncNanoId(), href: "/listing-car-map", name: "Cars page (map)" },
//           { id: ncNanoId(), href: "/listing-car-detail", name: "Car Detail" },
//         ],
//       },

//       //
//       {
//         id: ncNanoId(),
//         href: "/listing-real-estate",
//         name: "Real Estate Listings",
//         isNew: true,
//         type: "dropdown",
//         children: [
//           {
//             id: ncNanoId(),
//             href: "/listing-real-estate",
//             name: "Real Estate Listings",
//             isNew: true,
//           },
//           {
//             id: ncNanoId(),
//             href: "/listing-real-estate-map",
//             name: "Real Estate Maps",
//             isNew: true,
//           },
//         ],
//       },
//       //
//       {
//         id: ncNanoId(),
//         href: "/listing-flights",
//         name: "Flights listing",
//         isNew: true,
//       },
//     ],
//   },
//   {
//     id: ncNanoId(),
//     href: "/author",
//     name: "Templates",
//     type: "dropdown",
//     children: templatesChildrenMenus,
//   },

//   {
//     id: ncNanoId(),
//     href: "/blog",
//     name: "Other pages",
//     type: "dropdown",
//     children: otherPageChildMenus,
//   },
// ];
